import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Brand from '../components/Brand';
import ConsentCheckboxes from '../components/ConsentCheckboxes';

function Login({ onLogin }) {
  const navigate = useNavigate();
  const [method, setMethod] = useState('email');
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [smsConsent, setSmsConsent] = useState(false);
  const [termsConsent, setTermsConsent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (!identifier.trim() || !password.trim()) {
      setError('Please fill all fields');
      return;
    }

    onLogin({
      method,
      identifier,
      smsConsent,
      termsConsent,
      loggedInAt: new Date().toISOString(),
    });
    navigate('/home');
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <Brand />
        <h1 className="auth-title">Welcome back</h1>
        <p className="auth-subtitle">Sign in to access your Bluprint</p>

        <div className="tab-switcher">
          <button
            type="button"
            className={`tab-btn ${method === 'email' ? 'active' : ''}`}
            onClick={() => setMethod('email')}
          >
            Email
          </button>
          <button
            type="button"
            className={`tab-btn ${method === 'phone' ? 'active' : ''}`}
            onClick={() => setMethod('phone')}
          >
            Phone
          </button>
        </div>

        {error && <div className="error-msg">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">
              {method === 'email' ? 'Email address' : 'Phone number'}
            </label>
            <input
              className="form-input"
              type={method === 'email' ? 'email' : 'tel'}
              placeholder={method === 'email' ? 'you@example.com' : '+1 555 000 0000'}
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              className="form-input"
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Link to="/forgot-password" className="forgot-link">
              Forgot password?
            </Link>
          </div>

          <ConsentCheckboxes
            smsConsent={smsConsent}
            setSmsConsent={setSmsConsent}
            termsConsent={termsConsent}
            setTermsConsent={setTermsConsent}
          />

          <button type="submit" className="btn-primary">
            Sign In
          </button>
        </form>

        <div className="auth-links">
          Don't have an account? <Link to="/signup">Sign up</Link>
        </div>
      </div>
    </div>
  );
}

export default Login;
